import { createContext } from "react";

export const AppContext = createContext();
export const UserContext = createContext();
export const ThemeContext = createContext();
